<template>
  <div>
    <Subheader title="Password Reset" />

    <div class="app-content-column">
      <div class="card">
        <h5>Reset your password</h5>

        <form class="form" @submit.stop.prevent="sendResetPasswordEmail">
          <Field name="email">
            <input
              v-model="email"
              type="text"
              placeholder="Email"
              autocomplete="email"
              autocorrect="off"
              autocapitalize="none"
            />
          </Field>

          <div class="button-wrapper is-centered">
            <button type="submit" class="large-button">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import User from '@/services/users'
import Subheader from '@/components/Subheader'
import Field from '@/components/Field'

export default {
  name: 'ForgotPassword',
  components: {
    Subheader,
    Field,
  },
  data() {
    return {
      email: '',
    }
  },
  methods: {
    sendResetPasswordEmail() {
      User.api
        .sendResetPasswordEmail(this.email)
        .then(() => {
          this.$Alert.alert({
            type: 'success',
            message: `<h2>Password Reset Email Sent</h2>`,
            timeout: 3000,
          })
          this.$router.push({ name: 'Login' })
        })
        .catch(() => {
          this.$Alert.alert({
            type: 'error',
            message: `<h2>Error, please try again! If you continue to have issues, email mzingopartners@gmail.com</h2>`,
            timeout: 3000,
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/mixins/cards';
@import '../../styles/mixins/buttons';
@import '../../styles/forms';
@import '../../styles/layout';

.card {
  @include card-w-borders();
}
</style>
